import { cx } from 'cva';
import { type FunctionComponent } from 'react';
import CcmCross from '../../assets/images/ccm-cross.svg?url';
import { useTranslation } from '../../i18n/resources';
import styles from './PrayerStreamLogo.module.css';

export type PrayerStreamLogoProps = {
  className?: string;
};

export const PrayerStreamLogo: FunctionComponent<PrayerStreamLogoProps> = ({
  className,
}) => {
  const { t } = useTranslation();

  return (
    <div className={cx(styles.root, className)}>
      <div className={styles.header}>
        <img className={styles.cross} src={CcmCross} />
        <div className={styles.text}>{t('landingPage', 'prayerstream')}</div>
      </div>
    </div>
  );
};
